import { render } from "./RichAudio.vue?vue&type=template&id=d5b6e784&scoped=true"
import script from "./RichAudio.vue?vue&type=script&lang=js"
export * from "./RichAudio.vue?vue&type=script&lang=js"

import "./RichAudio.vue?vue&type=style&index=0&id=d5b6e784&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b6e784"]])

export default __exports__